import * as React from 'react'
import { getLogo } from '@/modules/branding/brandingService'

export default function MaintenancePage() {
  const [logo, setLogo] = React.useState<string | null>(null)

  React.useEffect(() => {
    let mounted = true
    ;(async () => {
      try {
        // Ordem de prioridade: maintenance > login > home (versão light, fundo preto)
        const fromMaintenance = await getLogo('maintenance', true)
        const fromLogin = fromMaintenance || await getLogo('login', true)
        const chosen = fromLogin || await getLogo('home', true)
        if (!mounted) return
        setLogo(chosen || '/crypto-logos/favicon.ico')
      } catch {
        if (!mounted) return
        setLogo('/crypto-logos/favicon.ico')
      }
    })()
    return () => { mounted = false }
  }, [])
  return (
    <div className="min-h-screen w-full bg-black text-white flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        {logo && (
          <img
            src={logo}
            alt="Cripto Alert"
            className="w-72 h-72 object-contain"
          />
        )}
        <p className="text-sm tracking-wide opacity-80">em breve...</p>
      </div>
    </div>
  )
}
